var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 20.6665H20.6925M5.16663 13.4332L5.16663 24.9923C5.16663 26.2561 5.16663 26.8879 5.30938 27.4825C5.43595 28.0097 5.6447 28.5137 5.92798 28.976C6.2475 29.4974 6.69429 29.9442 7.58787 30.8377L27.3985 50.6484C30.4676 53.7175 32.0022 55.2521 33.7717 55.827C35.3283 56.3328 37.005 56.3328 38.5615 55.827C40.331 55.2521 41.8656 53.7175 44.9348 50.6484L50.6485 44.9346C53.7176 41.8655 55.2522 40.3309 55.8271 38.5614C56.3329 37.0048 56.3329 35.3282 55.8271 33.7716C55.2522 32.0021 53.7176 30.4675 50.6485 27.3984L30.8379 7.58775C29.9443 6.69417 29.4975 6.24738 28.9761 5.92786C28.5138 5.64458 28.0098 5.43583 27.4827 5.30926C26.888 5.1665 26.2562 5.1665 24.9925 5.1665L13.4333 5.1665C10.5397 5.1665 9.09289 5.1665 7.98768 5.72964C7.01551 6.22498 6.22511 7.01538 5.72976 7.98755C5.16663 9.09276 5.16663 10.5396 5.16663 13.4332ZM21.9583 20.6665C21.9583 21.3799 21.38 21.9582 20.6666 21.9582C19.9533 21.9582 19.375 21.3799 19.375 20.6665C19.375 19.9531 19.9533 19.3748 20.6666 19.3748C21.38 19.3748 21.9583 19.9531 21.9583 20.6665Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.ad6344a348dd7d9116a8a2af787ce734.svg";
export { ForwardRef as ReactComponent };